<template>
  <div class="list-form">
    <div class="content">
      <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px">
        <div class="text">班次基本信息</div>
        <div class="form-row">
          <el-form-item label="班次名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入班次名称" maxlength="12" style="width: 300px;" clearable show-word-limit></el-input>
          </el-form-item>
        </div>
        <div class="text">上班打卡时间范围</div>
        <div class="form-row">
          <el-form-item label="上班时间" prop="startTime">
            <el-time-picker v-model="form.startTime" class="time-picker" :default-value="new Date(2026, 1, 1, 0, 0, 0)" format="HH:mm" value-format="HH:mm:ss" @change="changeStartTime" placeholder="请选择上班时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="上班前" prop="startTime1">
            <el-time-picker v-if="form.startTime" class="time-picker time-picker-none-prefix" v-model="form.startTime1" :default-value="new Date(2026, 1, 1, 0, 0, 0)" format="HH小时mm分"
              value-format="HH:mm" :picker-options="{
                selectableRange: '00:00:00 - 12:00:00'
              }" placeholder="请选择上班前时间">
            </el-time-picker>
            <el-input v-else placeholder="请选择上班前时间" readonly @click.native="chekTime('startTime', 'startTime1')"></el-input>
          </el-form-item>
          <el-form-item label="上班后" prop="startTime2">
            <el-time-picker v-if="form.startTime" class="time-picker time-picker-none-prefix" v-model="form.startTime2" :default-value="new Date(2026, 1, 1, 0, 0, 0)" format="HH小时mm分"
              value-format="HH:mm" :picker-options="{
                selectableRange: '00:00:00 - 12:00:00'
              }" placeholder="请选择上班后时间">
            </el-time-picker>
            <el-input v-else placeholder="请选择上班后时间" readonly @click.native="chekTime('startTime', 'startTime2')"></el-input>
          </el-form-item>
        </div>
        <div class="text">下班打卡时间范围</div>
        <div class="form-row">
          <el-form-item label="下班时间" prop="endTime">
            <el-time-picker v-if="form.startTime" v-model="form.endTime" :picker-options="endTimePickerOptions" class="time-picker" :default-value="new Date(2026, 1, 1, 0, 0, 0)" format="HH:mm" value-format="HH:mm:ss" @change="changeEndTime" placeholder="请选择下班时间">
            </el-time-picker>
            <el-input v-else placeholder="请选择下班时间" prefix-icon="el-icon-time" readonly @click.native="chekTime('startTime', 'endTime')"></el-input>
          </el-form-item>
          <el-form-item label="下班前" prop="endTime1">
            <el-time-picker v-if="form.endTime" class="time-picker time-picker-none-prefix" v-model="form.endTime1" :default-value="new Date(2026, 1, 1, 0, 0, 0)" format="HH小时mm分" value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:00:00 - 12:00:00'
              }" placeholder="请选择下班前时间">
            </el-time-picker>
            <el-input v-else placeholder="请选择下班前时间" readonly @click.native="chekTime('endTime', 'endTime1')"></el-input>
          </el-form-item>
          <el-form-item label="下班后" prop="endTime2">
            <el-time-picker v-if="form.endTime" class="time-picker time-picker-none-prefix" v-model="form.endTime2" :default-value="new Date(2026, 1, 1, 0, 0, 0)" format="HH小时mm分" value-format="HH:mm"
              :picker-options="clockOutAfterPickerOptions" @change="changeEndTime2" placeholder="请选择下班后时间">
            </el-time-picker>
            <el-input v-else placeholder="请选择下班后时间" readonly @click.native="chekTime('endTime', 'endTime2')"></el-input>
          </el-form-item>
        </div>
        <div class="text">休息时间</div>
        <div class="form-row">
          <el-form-item label=" " label-width="24px" style="width: 300px;">
            <el-checkbox v-model="form.restTime" @change="changeRestTime">休息时间</el-checkbox>
          </el-form-item>
          <el-form-item v-if="form.restTime" label="休息时间" prop="restTimeRange">
            <el-time-picker v-if="form.startTime && form.endTime" is-range v-model="form.restTimeRange"  :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
              }"  @change="changeRestTimeRange" format="HH:mm" value-format="HH:mm:ss" range-separator="至" start-placeholder="休息开始" end-placeholder="休息结束" placeholder="选择时间范围">
            </el-time-picker>
            <div v-else @click="chekTime('all', 'restTimeRange')" class="no-set-time-range">
              <i class="i el-icon-time"></i>
              <div class="t">休息开始</div>
              <div class="z">至</div>
              <div class="t">休息结束</div>
            </div>
          </el-form-item>
        </div>
        <div class="text">异常规则</div>
        <div class="form-row">
          <el-form-item label=" " label-width="24px" style="width: 300px;">
            <el-checkbox v-model="form.abnormal">迟到/早退升级旷工</el-checkbox>
          </el-form-item>
          <template v-if="form.abnormal">
            <el-form-item label="迟到/早退" prop="halfDay" style="width: 300px;">
              <el-input v-model="form.halfDay" maxlength="3" style="width: 50px;"  @input="val => form.halfDay = val.replace(/[^\d]/g, '')"></el-input>分钟为旷工半天
            </el-form-item>
            <el-form-item label="迟到/早退" prop="oneDay" style="width: 300px;">
              <el-input v-model="form.oneDay" maxlength="3" style="width: 50px;"  @input="val => form.oneDay = val.replace(/[^\d]/g, '')"></el-input>分钟为旷工一天
            </el-form-item>
          </template>
        </div>
      </el-form>
      <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
        <el-button type="info" plain @click="back">返回</el-button>
        <el-button type="primary" plain @click="reset">重置</el-button>
        <el-button type="primary" @click="save" :loading="btnSave">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { clockOutAfterSelectableRange, isClockOutWindowWithinSameDay, isRestRangeWithinShift, isShiftTimeOrderValid, validAbsenceThresholdOrder } from './shift-time'

export default {
  name: 'attendanceManagementListAdd',
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed
    },
    endTimePickerOptions () {
      return {
        selectableRange: `${this.form.startTime} - 23:59:59`
      }
    },
    clockOutAfterPickerOptions () {
      return {
        selectableRange: clockOutAfterSelectableRange(this.form.endTime)
      }
    },
    // restTimePickerOptions() {
    //   const startTime = this.form.startTime
    //   const endTime = this.form.endTime
    //   if (!startTime || !endTime) {
    //     return {}
    //   }
    //   return {
    //     selectableRange: `${startTime} - ${endTime}`
    //   }
    // }
  },
  data() {
    return {
      form: {
        name: '',
        startTime: '',
        startTime1: '',
        startTime2: '',
        endTime: '',
        endTime1: '',
        endTime2: '',
        restTime: false,
        restTimeRange: ['', ''],
        abnormal:false, //异常规则
        halfDay: '', 
        oneDay: '',

      },
      btnSave: false,
      rules: {
        name: [
          { required: true, message: '请输入班次名称', trigger: 'change' },
        ],
        startTime: [
          { required: true, message: '请选择上班时间', trigger: 'change' }
        ],
        startTime1: [
          { required: true, message: '请选择上班前时间', trigger: 'change' }
        ],
        startTime2: [
          { required: true, message: '请选择上班后时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择下班时间', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!value || !this.form.startTime || isShiftTimeOrderValid(this.form.startTime, value)) {
                callback()
              } else {
                callback(new Error('下班时间必须晚于上班时间'))
              }
            },
            trigger: 'change'
          }
        ],
        endTime1: [
          { required: true, message: '请选择下班前时间', trigger: 'change' }
        ],
        endTime2: [
          { required: true, message: '请选择下班后时间', trigger: 'change' }
        ],
        restTimeRange: [
           { required: true, type:'array', message: '请选择休息时间范围', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
                callback()
              } else {
                callback(new Error('请选择休息时间范围'))
              }
            },
            trigger: 'change'
          }
        ],
        halfDay: [
          { required: true, message: '请填写统计升级为旷工半天的条件', trigger: 'change' }
        ],
        oneDay: [
          { required: true, message: '请填写统计升级为旷工一天的条件', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!this.form.abnormal || !this.form.halfDay || !value) {
                callback()
              } else if (!validAbsenceThresholdOrder(this.form.halfDay, value)) {
                callback(new Error('旷工半天阈值必须小于旷工一天阈值'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
    }
  },
  activated() {
    let id = this.$route.query.id
    if (id) {
      this.getDetail(id)
    }else { 
      this.reset()
    }

  },
  created() {

  },
  methods: {
    clearClockOutTime () {
      this.form.endTime = ''
      this.form.endTime1 = ''
      this.form.endTime2 = ''
      if (this.form.restTime) {
        this.form.restTimeRange = ['', '']
      }
      this.$nextTick(() => this.$refs.form.clearValidate(['endTime', 'endTime1', 'endTime2', 'restTimeRange']))
    },
    // 改变上班时间后，依赖该时间的配置需要重新选择
    changeStartTime () {
      this.form.startTime1 = ''
      this.form.startTime2 = ''
      this.clearClockOutTime()
      this.$nextTick(() => this.$refs.form.clearValidate(['startTime1', 'startTime2']))
    },
    chekTime(setName, clearName) {
      if (setName === 'startTime') {
        this.$nextTick(() => {
          this.$refs.form.validateField('startTime')
          this.$refs.form.clearValidate(clearName)
        })
        this.$message.warning('请先选择上班时间')
      } else if (setName === 'endTime') {
        this.$nextTick(() => {
          this.$refs.form.validateField('endTime')
          this.$refs.form.clearValidate(clearName)
        })
        this.$message.warning('请先选择下班时间')
      } else if (setName === 'all') {
        this.$nextTick(() => {
          this.$refs.form.validateField('startTime')
          this.$refs.form.validateField('endTime')
          this.$refs.form.clearValidate(clearName)
        })
        this.$message.warning('请先选择上班和下班时间')
      }
    },
    changeStartTime1() {
      if (!this.form.startTime1) {
        this.$message.info('请先选择上班时间')
      }
    },
    changeRestTime(enabled) {
      // if (this.form.id) return false
      if (enabled) {
        this.$nextTick(() => {
          this.$refs.form.validateField('startTime')
          this.$refs.form.validateField('endTime')
        })
        if (this.form.startTime && this.form.endTime) {
          this.form.restTimeRange = [this.form.startTime, this.form.endTime]
        }else{
          this.form.restTime = false
        }
      } else {
        this.form.restTimeRange = ['', '']
        this.$refs.form.clearValidate('restTimeRange')
      }
    },
    changeRestTimeRange(timeRange) {
      if (!Array.isArray(timeRange) || timeRange.length !== 2 || !timeRange[0] || !timeRange[1]) {
        return
      }

      if (!isRestRangeWithinShift(timeRange, this.form.startTime, this.form.endTime)) {
        this.form.restTimeRange =  [this.form.startTime, this.form.endTime]
        this.$message.warning('休息时间必须在上下班时间范围内')
      }
    },
    changeEndTime () {
      if (this.form.endTime && !isShiftTimeOrderValid(this.form.startTime, this.form.endTime)) {
        this.clearClockOutTime()
        this.$message.warning('下班时间必须晚于上班时间')
        return
      }
      if (!this.form.endTime2 || isClockOutWindowWithinSameDay(this.form.endTime, this.form.endTime2)) {
        return
      }
      this.form.endTime2 = ''
      this.$nextTick(() => this.$refs.form.clearValidate('endTime2'))
      this.$message.warning('必须选当天时间')
    },
    changeEndTime2 (value) {
      if (!value || !this.form.endTime) {
        return
      }
      if (!isClockOutWindowWithinSameDay(this.form.endTime, value)) {
        this.form.endTime2 = ''
        this.$nextTick(() => this.$refs.form.clearValidate('endTime2'))
        this.$message.warning('必须选当天时间')
        return
      }
      if (this.form.restTime) {
        this.form.restTimeRange = ['', '']
        this.$nextTick(() => this.$refs.form.clearValidate('restTimeRange'))
      }
    },
    timeToMinutes(timeText) {
      if (!timeText) {
        return ''
      }
      return timeText.trim().split(/\s+/).map(time => {
        const [hours, minutes] = time.split(':').map(Number)
        return hours * 60 + minutes
      })
    },
    minutesToTime(minutes) {
      if (minutes === '' || minutes === null || minutes === undefined) {
        return ''
      }
      const totalMinutes = Number(minutes)
      if (!Number.isFinite(totalMinutes)) {
        return ''
      }
      const hours = Math.floor(totalMinutes / 60).toString().padStart(2, '0')
      const remainingMinutes = (totalMinutes % 60).toString().padStart(2, '0')
      return `${hours}:${remainingMinutes}`
    },
    back() {
      this.$router.go(-1)
    },
    reset() {
      let id = this.$route.query.id
      if (id) {
        this.getDetail(id)
      }else { 
        this.$refs.form.resetFields()
        this.form.restTime = false
        this.form.abnormal = false
      }
    },
    save() {
      const postData = {
        name: this.form.name,
        clockInTime: this.form.startTime,
        clockInBeforeMinutes: this.timeToMinutes(this.form.startTime1)[0],
        clockInAfterMinutes: this.timeToMinutes(this.form.startTime2)[0],
        clockOutTime: this.form.endTime,
        clockOutBeforeMinutes: this.timeToMinutes(this.form.endTime1)[0],
        clockOutAfterMinutes: this.timeToMinutes(this.form.endTime2)[0],
        restEnabled: this.form.restTime,
        restStartTime: this.form.restTimeRange[0],
        restEndTime:this.form.restTimeRange[1],
        absenceUpgradeEnabled: this.form.abnormal,
        halfDayThresholdMinutes: this.form.halfDay,
        fullDayThresholdMinutes: this.form.oneDay,
      }
      let APIURL = ''
      let message = ''
      // 是否编辑
      if (this.form.id) {
        postData.id = this.form.id
        postData.versionNo = this.form.versionNo
        APIURL = 'shiftsEdit'
        message = '编辑成功'

      }else{
        APIURL = 'shiftsAdd'
        message = '添加成功'
      }
      console.log('>>')
      this.$refs.form.validate((valid) => {
        // return
        if (valid) {
          this.btnSave = true
          this.$api[APIURL](postData).then((res) => {
            if (res.code == 0) {
              this.$message({ message, type: 'success' })
              this.back()
            }
          }).finally(() => {
            this.btnSave = false
          })
        }
      })
    },
    getDetail(id) {
      this.$api.shiftsDetail(id).then((res) => {
        if (res.code == 0) {
          let detail = res.data
          this.form.id = detail.id
          this.form.versionNo = detail.versionNo
          this.form.name = detail.name
          this.form.startTime = detail.clockInTime
          this.form.startTime1 = this.minutesToTime(detail.clockInBeforeMinutes)
          this.form.startTime2 = this.minutesToTime(detail.clockInAfterMinutes)
          this.form.endTime = detail.clockOutTime
          this.form.endTime1 = this.minutesToTime(detail.clockOutBeforeMinutes)
          this.form.endTime2 = this.minutesToTime(detail.clockOutAfterMinutes)
          this.form.restTime = detail.restEnabled
          this.form.restTimeRange =[detail.restStartTime,detail.restEndTime]
          this.form.abnormal = detail.absenceUpgradeEnabled
          this.form.halfDay = detail.halfDayThresholdMinutes
          this.form.oneDay = detail.fullDayThresholdMinutes
          console.log(res.data)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 118px);
  margin-top: 16px;
  padding: 0 16px 84px;
  box-sizing: border-box;
  margin-bottom: 35px;
  background-color: #FFFFFF;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;


}

.data-title {
  width: 100%;
  height: 32px;
  margin-top: 20px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 9px;
    width: 2px;
    height: 16px;
    background: #00B498;
    border-radius: 0px 0px 0px 0px;
  }

  .title-name {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #2F3030;
    margin-left: 6px;
    line-height: 32px;
  }

}

.text {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #2F3030;
  margin-top: 32px;
  margin-bottom: 30px;
}

.forms {
  flex: 1;

  // /deep/{
  //     .el-form{
  //         display: flex;
  //         flex-wrap: wrap;
  //     }
  //     .el-form-item{
  //         // flex: 1;
  //         display: flex;
  //         flex-wrap: wrap;
  //     }
  //     .el-form-item__label{
  //         white-space: nowrap;
  //         flex-shrink: 0;
  //     }
  // }
  /deep/ .el-textarea {
    .el-textarea__inner {
      padding-left: 8px;
      width: 204px;
      height: 64px;
    }

    .el-input__count {
      line-height: 1;
      bottom: 6px;
    }
  }

  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #2F3030;
  }

  .input-con {
    display: flex;

    .input {
      flex: 1;
      width: 164px;
      line-height: 1;

      /deep/.el-input__inner {
        border-right: none;
        border-radius: 4px 0 0 4px;
      }
    }

    .btn-copy {
      width: 40px;
      height: 32px;
      border-radius: 0 4px 4px 0;
      background-color: #00B498;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #FFF;
      cursor: pointer;
    }

    .btn-copy-dis {
      background-color: #E3E6E5;
      cursor: default;
    }
  }
}


/* 底部按钮 */
.footer {
  height: 84px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 200px;
  right: 0;
  bottom: 0;
  border-top: 1px solid #EDF2F2;
  box-sizing: border-box;
  transition: left 0.3s ease-in-out;
  z-index: 2;

  .el-button {
    min-width: 88px;
    padding: 12px 20px 10px;
  }

  .el-button+.el-button {
    margin-left: 16px;
  }
}

.footer-collapsed {
  left: 80px;
}

.time-picker {
  width: 204px;
}

.no-set-time-range {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 350px;
  height: 32px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E3E6E5;
  color: #2F3030;
  box-sizing: border-box;
  padding: 3px 71px 3px 10px;
  .i{
    color: #C0C4CC;
  }
  .t{
    color: #C0C4CC;
    font-family: Arial, Helvetica, sans-serif
  }
}
.is-error .no-set-time-range{
  border-color: #F56C6C;
}
</style>
